import React from 'react'

function Home({details}) {
  const {title, subtitle, description, highlights} = details;

  return (
    <>
    <div className="container-1">
      <div className="card">
        <h1>{title}</h1>
        <h2>{subtitle}</h2>
        <p>{description}</p>

        <div className="highlights">
          <h3>our Highlights</h3>
          {highlights.map((highlight, index) =>(
            <li key={index}>{highlight}</li>
          ))}
        </div>
      </div>
    </div>
    </>
  )
}

export default Home
